import { IBankSettingsContext } from './bankSettingsContext';

export enum BankSettingsActionsTypes {
	REFETCH_DATA = 'REFETCH_DATA',
	SET_BANK_SETTINGS = 'SET_BANK_SETTINGS',
	SET_INITIAL_FORM_DATA = 'SET_INITIAL_FORM_DATA',
	SET_FETCHED_ACQUIRERS = 'SET_FETCHED_ACQUIRERS',
	SET_DATA_FOR_SUBMIT = 'SET_DATA_FOR_SUBMIT',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface IRefetchData {
	type: BankSettingsActionsTypes.REFETCH_DATA;
	payload: {
		needRefetchData: IBankSettingsContext['needRefetchData'];
	};
}

interface ISetBankSettings {
	type: BankSettingsActionsTypes.SET_BANK_SETTINGS;
	payload: {
		bankSettings: IBankSettingsContext['bankSettings'];
	};
}

interface ISetInitialFormData {
	type: BankSettingsActionsTypes.SET_INITIAL_FORM_DATA;
	payload: {
		initialFormData: IBankSettingsContext['initialFormData'];
	};
}

interface ISetFetchedAcquirers {
	type: BankSettingsActionsTypes.SET_FETCHED_ACQUIRERS;
	payload: {
		fetchedAcquirers: IBankSettingsContext['fetchedAcquirers'];
	};
}

interface ISetDataForSubmit {
	type: BankSettingsActionsTypes.SET_DATA_FOR_SUBMIT;
	payload: {
		dataForSubmit: IBankSettingsContext['dataForSubmit'];
	};
}

interface IChangeTypeOfModalWindow {
	type: BankSettingsActionsTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: IBankSettingsContext['typeOfModalWindow'];
	};
}

export type TBankSettingsAction =
	| IRefetchData
	| ISetBankSettings
	| ISetInitialFormData
	| ISetFetchedAcquirers
	| ISetDataForSubmit
	| IChangeTypeOfModalWindow;
